import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface PromoCodeMessage {
  message: string;
  promoCode: string;
}

interface TrustItem {
  headerIconURL: string;
  headerText: string;
  heading: string;
  links: {
    href: string;
    text: string;
  }[];
  subHeading: string;
}

export interface ContentState {
  promoCodeMessage?: PromoCodeMessage;
  trustItems: TrustItem[];
}

export const initialState: ContentState = {
  trustItems: [],
};

export const { actions, reducer } = createSlice({
  name: 'content',
  initialState,
  reducers: {
    setContent: (state, { payload }: PayloadAction<ContentState>) => {
      if (payload.promoCodeMessage) {
        state.promoCodeMessage = payload.promoCodeMessage;
      }

      state.trustItems = payload.trustItems;
    },
  },
});
